import {
  ThumbUpAltOutlined as ThumbUpAltOutlinedIcon,
  ThumbDownAltOutlined as ThumbDownAltOutlinedIcon,
} from '@mui/icons-material';
import { ButtonGroup, IconButton } from '@mui/material';
import { useCallback } from 'react';

import { useParentHelperContext } from 'applications/GSP/pages/ParentHelper/providers/ParentHelperProvider/hooks';
import { useDialog } from 'shared/components/Dialog';
import { useMediaQuery } from 'shared/hooks/dom';

import { FeedbackDislikeDialog } from './components/FeedbackDislikeDialog';
import { Provider } from './context';

import type { FeedbackButtonsProps } from './types';
import type { FC } from 'react';

const ICON_BUTTON_PADDING = 0.5;

export const FeedbackButtons: FC<FeedbackButtonsProps> = ({ messageId }) => {
  const matches = useMediaQuery('md', 'down');
  const fontSize = matches ? 'medium' : 'small';

  const dialog = useDialog();

  const { likeMessage, deletedChatId } = useParentHelperContext();

  const onLikeMessage = useCallback(
    () => likeMessage(messageId),
    [messageId, likeMessage],
  );

  // TODO: remove after adding Notistack
  if (deletedChatId) {
    return null;
  }

  return (
    <Provider value={{ ...dialog, messageId }}>
      <ButtonGroup
        sx={{
          mt: 1,
          display: { xs: 'block', md: 'none' },
          position: { xs: 'initial', md: 'absolute' },
        }}
      >
        <IconButton sx={{ p: ICON_BUTTON_PADDING }} onClick={onLikeMessage}>
          <ThumbUpAltOutlinedIcon fontSize={fontSize} />
        </IconButton>
        <IconButton sx={{ p: ICON_BUTTON_PADDING }} onClick={dialog.onOpen}>
          <ThumbDownAltOutlinedIcon fontSize={fontSize} />
        </IconButton>
      </ButtonGroup>
      <FeedbackDislikeDialog />
    </Provider>
  );
};
